<template>
  <div class="signin">
    <div class="header">
      <div class="common_content clearfix">
        <div class="header_left">{{ title }}</div>
        <div class="header_right">
          <router-link to="/">
            <el-link :underline="false" style="padding:0px 10px;">返回首页</el-link>
          </router-link>
        </div>
      </div>
    </div>
    <div class="common_content">
      <img src="/image/index/logo.png" alt style="padding:30px 0px 30px 0px;"/>
    </div>
    <div
        class="backgrond common_backgroundImg"
        :style="updataStatus?'height:470px;':'height:580px;'"
    >
      <el-card class="box-card">
        <div class="signin_title">
          <h2>{{ updataStatus ? '登录账号' : '找回密码' }}</h2>
        </div>
        <div class="signin_form" v-show="updataStatus">
          <el-form
              :model="ruleForm"
              status-icon
              :rules="rules"
              ref="ruleForm"
              class="demo-ruleForm"
          >
            <el-form-item>
              <div class="signin_radio" prop="usertype">
                <el-radio-group
                    v-model="ruleForm.usertype"
                    v-for="(item,index) in roleList"
                    :key="index"
                >
                  <el-radio :label="item.label">{{ item.value }}</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item prop="loginName" :error="errorUser">
              <div style="text-align: center;position: relative">
                <el-input
                    placeholder="请输入您的账号"
                    v-model="ruleForm.loginName"
                    clearable
                    prefix-icon="el-icon-user-solid"
                ></el-input>
                <el-tooltip class="username_question" effect="dark"
                            placement="bottom" v-if="ruleForm.usertype == 1">
                  <div slot="content">通过测试机构批量报名注册的运动员<br/>第一次登录请使用相应证件号码进行登录</div>
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </el-form-item>
            <el-form-item prop="password" :error="errorPass">
              <div style="text-align: center;">
                <el-input
                    placeholder="请输入您的密码"
                    v-model="ruleForm.password"
                    clearable
                    prefix-icon="el-icon-lock"
                    show-password
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div style="text-align: center;margin:15px 0px 0px 0px">
                <el-button
                    type="danger"
                    style="width:150px;height:40px"
                    @click="signin('ruleForm')"
                    :loading="loading"
                >立即登录
                </el-button>
              </div>
            </el-form-item>
            <div class="refor">
              <el-link type="danger" @click="updataStatus = false">忘记密码</el-link>
              <el-link type="primary" @click="register">去注册</el-link>
            </div>
          </el-form>
        </div>
        <div class="signin_form" v-show="!updataStatus">
          <el-form
              :model="updataRuleForm"
              status-icon
              :rules="updataRules"
              ref="updataRuleForm"
              label-width="85px"
              class="demo-ruleForm"
          >
            <el-form-item class="signin_radio_partient">
              <div class="signin_radio" prop="usertype">
                <el-radio-group
                    v-model="updataRuleForm.usertype"
                    v-for="(item,index) in roleList"
                    :key="index"
                >
                  <el-radio :label="item.label">{{ item.value }}</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item label="手机号码" prop="mobile">
              <el-input v-model="updataRuleForm.mobile" placeholder="请输入您手机号" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="code">
              <el-input
                  v-model="updataRuleForm.code"
                  placeholder="短信验证码"
                  autocomplete="off"
                  maxlength="4"
              >
                <el-button
                    class="verificationCode"
                    slot="append"
                    @click="getCode('updataRuleForm')"
                    :disabled="timeLoading"
                    style="color: #67c23a"
                >{{ !timeLoading ? '获取验证码' : checkTime + 'S重新获取' }}
                </el-button>
              </el-input>
            </el-form-item>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="登录密码" prop="pwd">
                <el-input
                    type="password"
                    v-model="updataRuleForm.pwd"
                    maxlength="18"
                    show-password
                    placeholder="请输入登录密码"
                    auto-complete="new-password"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="确认密码" prop="confirmpwd">
                <el-input
                    type="password"
                    v-model="updataRuleForm.confirmpwd"
                    maxlength="18"
                    show-password
                    placeholder="请确认登录密码"
                    auto-complete="new-password"
                ></el-input>
              </el-form-item>
            </el-col>
            <div style="text-align: center;margin:15px 0px 0px 0px">
              <el-button
                  type="danger"
                  style="width:150px;height:40px"
                  @click="save('updataRuleForm')"
              >提 交
              </el-button>
            </div>
            <div style="text-align: center;margin:15px 0px 0px 0px" v-if="false">
              <el-button
                  type="danger"
                  style="width:150px;height:40px"
                  @click="clearValidate('updataRuleForm')"
              >提 交
              </el-button>
            </div>
            <div class="refor">
              <el-link type="danger"></el-link>
              <el-link
                  type="danger"
                  @click="updataStatus = true"
                  icon="el-icon-back"
                  class="back"
              >返 回
              </el-link>
            </div>
          </el-form>
        </div>
      </el-card>
    </div>
    <div class="foot">
      <foot :content="this.$route.meta.bottomFlag"/>
    </div>
  </div>
</template>
<script>
import foot from "@/views/admin/components/foot.vue";
import {isMobile} from "@/util/validate.js";
import {ForgetPassword, GetMessageCode} from "@/api/admin/login.js";
import {encryption} from "@/util/encryption.js";

var checkmobile = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入联系方式"));
  } else {
    if (isMobile(value)) {
      callback();
    } else {
      return callback(new Error("请输入正确的电话"));
    }
  }
};
var checkCode = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入验证码"));
  } else {
    if (String(value).length == 4) {
      callback();
    } else {
      return callback(new Error("请输入四位数验证码"));
    }
  }
};
var validatePass = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入密码"));
  } else {
    if (String(value).length < 6) {
      callback(new Error("密码不足6位"));
    } else if (String(value).length < 19) {
      callback();
    } else {
      callback(new Error("密码过长"));
    }
  }
};
/*var validatePass = (rule, value, callback) => {
  let reg = /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{8,20}$/
  let valid = reg.test(value);
  if (!valid) {
    callback(new Error("密码应不少于8位，且应包含数字、大写字母、小写字母、特殊字符中的至少3种"));
  }else {
    callback();
  }
};*/
export default {
  components: {
    foot
  },
  data() {
    var checkPassWord = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入登录密码"));
      } else if (value !== this.updataRuleForm.pwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      title: "欢迎来到羽毛球运动水平等级评定!",
      roleList: [
        {
          label: 1,
          value: "运动员"
        },
        {
          label: 2,
          value: "考评员"
        },
        {
          label: 3,
          value: "测试机构"
        }
      ],
      ruleForm: {
        usertype: 1,
        loginName: "",
        password: ""
      },
      rules: {
        loginName: [
          {required: true, message: "账号不能为空", trigger: "blur"}
        ],
        password: [{validator: validatePass, trigger: "blur"}]
      },
      errorPass: "",
      errorUser: "",
      updataRuleForm: {
        usertype: 1,
        code: "",
        confirmpwd: "",
        pwd: "",
        mobile: ""
      },
      updataRules: {
        code: [{validator: checkCode, trigger: "blur"}],
        mobile: [{validator: checkmobile, trigger: "blur"}],
        pwd: [{validator: validatePass, trigger: "blur"}],
        confirmpwd: [{validator: checkPassWord, trigger: "blur"}]
      },
      updataStatus: true,
      checkTime: "",
      timeLoading: false,
      timer: null,
      loading: false
    };
  },
  watch: {
    updataStatus() {
      this.clear();
    }
  },
  created() {
  },
  methods: {
    signin(ruleForm) {
      this.errorPass = "";
      this.errorUser = "";
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          this.loading = true
          let form = {
            usertype: this.ruleForm.usertype,
            loginName: encryption(this.ruleForm.loginName),
            password: encryption(this.ruleForm.password)
          };
          this.$store.dispatch("Login", form).then(data => {

            this.loading = false
            if (data.isSuccess) {
              if (data.userData.isverify) {
                this.$store
                    .dispatch("GetPersonalInfo", data.userData)
                    .then(item => {
                      this.$notify.success({
                        title: "提示",
                        message: "登录成功",
                        duration: 1000
                      });
                      if (item.userInfo) this.$router.push({path: "/"});
                      else {
                        var pathList = [
                          {title: "您当前的位置"},
                          {title: "首页", path: "/index"},
                          {path: "/personal", title: "个人中心"},
                          {
                            title: "完善信息"
                          }
                        ];
                        setTimeout(() => {
                          this.$store.commit("SET_ROUTELIST", pathList);
                        });
                        this.$router.push({
                          path: "/personal/completeInformation"
                        });
                      }
                    });
              } else {
                this.$router.push({path: "/bindMobile"});
              }
            } else {
              this.$notify.error({
                title: "提示",
                message: data.errorMsg,
                duration: 1000
              });
            }
          }).catch(() => {
            this.loading = false
          });
        } else {
          return false;
        }
      });
    },
    register() {
      this.$router.push({path: "/register"});
    },
    getCode(updataRuleForm) {
      this.$refs[updataRuleForm].validateField("mobile", errMsg => {
        if (!errMsg) {
          GetMessageCode({mobile: this.updataRuleForm.mobile}).then(data => {
            const list = data.data.result;
            if (list) {
              if (list.isSuccess) {
                this.$message({
                  message:
                      "验证码已成功发送至“ " +
                      this.updataRuleForm.mobile +
                      " ”请您注意查收",
                  type: "success",
                  duration: "5000"
                });
                if (!this.timer) {
                  this.checkTime = 120;
                  this.timeLoading = true;
                  this.timer = setInterval(() => {
                    if (this.checkTime > 0 && this.checkTime <= 120) {
                      this.checkTime--;
                    } else {
                      clearInterval(this.timer);
                      this.timeLoading = false;
                      this.timer = null;
                    }
                  }, 1000);
                }
              } else {
                this.$message.error("验证码发送失败，请重新获取");
              }
            }
          });
        }
      });
    },
    save(updataRuleForm) {
      this.$refs[updataRuleForm].validate(valid => {
        if (valid) {
          ForgetPassword(this.updataRuleForm).then(data => {

            const list = data.data.result;
            if (list) {
              if (list.isSuccess) {
                this.updataStatus = true;
                this.clear();
              } else {
                this.$message({
                  message: list.errorMsg,
                  type: "warning",
                  duration: "3000"
                });
              }
            }
          });
        } else {
          return false;
        }
      });
    },
    clear() {
      this.updataRuleForm = {
        usertype: 1,
        code: "",
        confirmpwd: "",
        pwd: "",
        mobile: ""
      };
      this.clearValidate("updataRuleForm");
    },
    clearValidate(updataRuleForm) {
      this.$refs[updataRuleForm].resetFields();
    }
  }
};
</script>

<style lang="less">
.username_question {
  position: absolute;
  margin-left: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.signin {
  .header {
    /* Rectangle 137 */
    width: 100%;
    height: 42px;
    line-height: 42px;
    left: 0px;
    top: 0px;
    background: rgba(244, 244, 244, 0.85);

    .header_left {
      font-family: Source Han Sans CN;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      color: #000000;
      float: left;
    }

    .header_right {
      float: right;
    }
  }

  .backgrond {
    /* 背景1 4 */
    width: 100%;
    // height: 580px;
    background-image: url(/image/index/yumaoqiu3344.png);
    position: relative;

    .box-card {
      width: 28%;
      position: absolute;
      top: 7%;
      right: 8%;

      .signin_title {
        text-align: center;
        // position: relative;
        // .back{
        //    position: absolute;
        //    left:30px;
        //    top:18px;
        // }
        h2 {
          display: inline-block;
          border-bottom: 2px solid #ea0000;
          border-radius: 2px;
          padding: 10px;
        }
      }

      .signin_form {
        padding: 10px 30px;

        .signin_radio_partient {
          .el-form-item__content {
            margin-left: 0px !important;
          }
        }

        .signin_radio {
          display: flex;
          justify-content: space-around;
          margin: 30px 0px 0px 0px;
        }

        .verificationCode {
          font-size: 14px;
          width: 130px;
          color: #67c23a;
        }

        .refor {
          display: flex;
          justify-content: space-between;
        }
      }
    }

    @media screen and (max-width: 1200px) {
      .box-card {
        width: 60%;
        right: 0px;
        left: 0px;
        margin: 0 auto;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .signin {
    .header {
      .header_left {
        font-size: 15px;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .signin {
    .backgrond {
      .box-card {
        width: 90%;

        .el-card__body {
          padding: 20px 10px;

          .signin_title {
            h2 {
              font-size: 18px;
            }
          }

          .signin_form {
            padding: 10px 4px;

            .verificationCode {
              width: 90px;
              font-size: 12px;
            }
          }
        }
      }
    }
  }

  .username_question {
    position: absolute;
    margin-left: 1px;
    top: 50%;
    transform: translateY(-50%);
  }
}

@media screen and (max-width: 320px) {
  .signin {
    .header {
      .header_left {
        display: none;
      }
    }

    .common_content {
      img {
        width: 100%
      }
    }
  }
}


</style>
